export const investBannerConfig = {
  experimentName: 'invest-banner',
  variants: ['number-variant-a', 'number-variant-b'],
  section: 'srp_side_section',
};

export const enquireFromCarouselConfig = {
  experimentName: 'carousel-enquiry',
  variants: ['control', 'variant'],
  section: 'desktop-web-pdp-carousel-enquiry',
};

const activeExperiments = [enquireFromCarouselConfig];

export default activeExperiments;
